export const firebaseConfig = {
    apiKey: "AIzaSyAJVf62dO8nyD9v-8ZoP2uNIW6VNBKZa7o",
    authDomain: "dm-tools-fd55a.firebaseapp.com",
    projectId: "dm-tools-fd55a",
    storageBucket: "dm-tools-fd55a.appspot.com",
    messagingSenderId: "57158610461",
    appId: "1:57158610461:web:db38e27d58514d957220f4"
};

export default firebaseConfig;